import { PackagePlus, ShieldCheck, Workflow, type LucideIcon } from 'lucide-react';
import wordmarkWhiteUrl from '../../assets/vivicta-wordmark-white.svg';

type PortalCapability = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export const PORTAL_CAPABILITIES: PortalCapability[] = [
  {
    icon: PackagePlus,
    title: 'Application onboarding',
    description:
      'Provision repositories, pipelines and environments from approved templates.',
  },
  {
    icon: Workflow,
    title: 'Agent operations',
    description:
      'Follow automation runs and workflow health across every service you own.',
  },
  {
    icon: ShieldCheck,
    title: 'Governance and compliance',
    description:
      'Review policy findings and compliance posture without leaving the portal.',
  },
];

export const SignInBrandPanel = () => (
  <aside className="relative hidden overflow-hidden bg-primary p-12 text-primary-foreground dark:bg-secondary dark:text-secondary-foreground lg:flex lg:flex-col lg:justify-between xl:p-16">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-primary-foreground/5 blur-3xl dark:bg-secondary-foreground/5"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-40 -right-24 h-96 w-96 rounded-full bg-primary-foreground/5 blur-3xl dark:bg-secondary-foreground/5"
    />

    <div className="relative flex items-center gap-4">
      <img src={wordmarkWhiteUrl} alt="Vivicta" className="h-6 w-auto" />
      <span className="text-xs font-semibold uppercase tracking-widest opacity-70">
        Developer Portal
      </span>
    </div>

    <div className="relative max-w-md">
      <h2 className="text-3xl font-semibold leading-tight tracking-tight xl:text-4xl">
        Build, run and govern Vivicta software in one place.
      </h2>
      <p className="mt-4 text-sm leading-relaxed opacity-75">
        The portal connects application delivery, agent automation and compliance
        evidence, so teams can ship without stitching tools together.
      </p>

      <ul className="mt-10 flex flex-col gap-7">
        {PORTAL_CAPABILITIES.map(({ icon: Icon, title, description }) => (
          <li key={title} className="flex gap-4">
            <Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 opacity-80" />
            <div className="min-w-0">
              <p className="text-sm font-semibold">{title}</p>
              <p className="mt-1 text-sm leading-relaxed opacity-70">{description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>

    <p className="relative text-xs opacity-60">
      Internal platform. Access is granted through the Vivicta organisation.
    </p>
  </aside>
);
